var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.457,
    height: 23.97,
    viewBox: "0 0 22.457 23.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2368",
    "data-name": "Groupe 2368",
    transform: "translate(22.457 0.756) rotate(92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1088",
    "data-name": "Trac\\xE9 1088",
    d: "M9.381,20.044,0,0,20.658,7.527l-5.417,3.982L22.49,18.2l-2.469,2.726-7.25-6.69Z",
    transform: "translate(0.369 0.368)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1089",
    "data-name": "Trac\\xE9 1089",
    d: "M12.985,14.268a.388.388,0,0,1,.1-.03.37.37,0,0,1,.3.093l6.976,6.437,1.974-2.179-6.982-6.442a.369.369,0,0,1,.031-.567l4.863-3.574L1.081,1.02l8.7,18.6,3.036-5.2a.372.372,0,0,1,.162-.149m7.562,7.358a.353.353,0,0,1-.139.034.368.368,0,0,1-.267-.1l-6.912-6.379L10.067,20.6a.372.372,0,0,1-.336.182.368.368,0,0,1-.317-.212L.035.525a.369.369,0,0,1,.46-.5L21.153,7.549a.368.368,0,0,1,.092.643l-5.057,3.717,6.922,6.386a.368.368,0,0,1,.023.518l-2.468,2.727a.363.363,0,0,1-.117.087",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.9213eca71beb0aaed4b22c13275f1b65.svg";
export { ForwardRef as ReactComponent };